import { useState } from 'react';
import { API_URL } from '@constants';
import { GetUserTypesSuccessResponse } from '@types';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/usr-users/types';

/**
 * Requests endpoint to get all user types.
 */
export const useGetUserTypes = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const [userTypes, setUserTypes] = useState<GetUserTypesSuccessResponse['data']>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const request = async () => {
        setLoading(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetUserTypesSuccessResponse = await response.json();

            setUserTypes(data.data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setLoading(false);
        }
    };

    return { request, userTypes, loading };
};